import { HiOutlineHome, HiOutlineCalendar, HiOutlineDocumentText } from 'react-icons/hi';
import { MenuItem } from '.';
import { pathnames } from 'routes/lia';

const liaMenu: MenuItem[] = [
  {
    name: 'Overview',
    url: pathnames.overview,
    icon: HiOutlineHome,
    children: [],
    role: ['superadmin']
  },
  {
    name: 'Assessment Schedules',
    url: pathnames.assessmentSchedules,
    icon: HiOutlineCalendar,
    children: [],
    role: ['superadmin']
  },
  {
    name: 'Questions',
    url: '#',
    icon: HiOutlineDocumentText,
    children: [
      {
        name: 'Question',
        url: pathnames.questions,
        role: ['superadmin']
      },
      {
        name: 'Group Question',
        url: pathnames.groupQuestions,
        role: ['superadmin']
      },
      {
        name: 'Group Question (Admin)',
        url: pathnames.groupQuestions,
        role: ['admin']
      },
      {
        name: 'Range Template',
        url: pathnames.rangeTemplates,
        role: ['superadmin']
      }
    ],
    role: ['superadmin']
  }
];

export const LIA_MENU = liaMenu;
